module.exports = __webpack_public_path__ + "static/media/The Gates.d78457a2.mp3";